//@ts-nocheck
import NotFound from "./Components/NotFound";
import Dashboard from "./Pages/dashboard/dashboard";
import QuotesDashboard from "./Pages/quotations";
import CreateQuote from "./Pages/quotations/add";
import QuoteForm from "./Pages/quotations/quoteForm";
import CategoryMaster from "./Pages/category/category";
import SourceMaster from "./Pages/source/source";
import RepresentativeMaster from "./Pages/representative/representative";
import OTCSnapshot from "./Pages/otc/otc";
import OrderTracking from "./Pages/order-tracking/order-tracking";
import OpenOrder from "./Pages/open-order/open-order";
import CreateOrderTracking from "./Pages/order-tracking/create";
import InventoryPage from "./Pages/inventory/inventory";
import Admin from "./Pages/admin/admin";
import EmailPage from "./Pages/email/email";
import CustomerEmailPage from "./Pages/customer-email/customer-email";
import DealerEmailPage from "./Pages/dealer-email/dealer-email";
import LoginPage from "./Pages/login/login";
import Quotes from "./Pages/quotes/QuotesWtb";
import QuotesResponses from "./Pages/quotes/QuotesResponses";
import QuotesResponsesSimple from "./Pages/quotes/QuotesResponsesSimple";
import PendingQuoteResponses from "./Pages/quotes/PendingQuoteResponses";
import CompanyMaster from "./Pages/company/company";
import OfficesMaster from "./Pages/offices/offices";
import SettingsPage from "./Pages/settings/settings";
import ProfilePage from "./Pages/profile/profile";
import LogsPage from "./Pages/logs/logs";
import AteDashboard from "./Pages/ate-dashboard/ate-dashboard";

const AdminRoutes = [
  // {
  //  path : "/customer/add",
  //  name : "Customer Form",
  //  component : CustomerMasterForm,
  //  exact : true
  // },
  // {
  //  path : "/customer/:id/edit",
  //  name : "Customer Form",
  //  component : CustomerEditForm ,
  //  exact : true
  // },
  {
    path: "/",
    name: "Login Page",
    component: LoginPage,
  },
  {
    path: "/dashboard",
    name: "Customers",
    component: Dashboard,
  },
  {
    path: "/ate-dashboard",
    name: "ATE Dashboard",
    component: AteDashboard,
  },
  {
    path: "/quotations/quoteForm",
    name: "Quote Form",
    component: QuoteForm,
  },
  {
    path: "/Quotes",
    name: "Customers",
    component: CreateQuote,
  },
  {
    path: "/quotations",
    name: "Customers",
    component: QuotesDashboard,
  },
  {
    path: "/category",
    name: "Category Master",
    component: CategoryMaster,
  },
  {
    path: "/source",
    name: "Source Master",
    component: SourceMaster,
  },
  {
    path: "/representative",
    name: "Representative Master",
    component: RepresentativeMaster,
  },
  {
    path: "/company",
    name: "Company Master",
    component: CompanyMaster,
  },
  {
    path: "/offices",
    name: "Offices Master",
    component: OfficesMaster,
  },
  {
    path: "/otc",
    name: "OTC Snapshot",
    component: OTCSnapshot,
  },
  {
    path: "/quotes-wtb",
    name: "Quotes WTB",
    component: Quotes,
  },
  {
    path: "/quotes-responses",
    name: "Quotes Responses",
    component: QuotesResponses,
  },
  {
    path: "/quotes-responses-simple",
    name: "Quotes Responses Simple",
    component: QuotesResponsesSimple,
  },
  {
    path: "/pending-quote-responses",
    name: "Pending Quote Responses",
    component: PendingQuoteResponses,
  },
  {
    path: "/order-tracking",
    name: "Order Tracking Center",
    component: OrderTracking,
  },
  {
    path: "/order-tracking/create",
    name: "Create Order Tracking",
    component: CreateOrderTracking,
  },
  {
    path: "/open-order",
    name: "Open Order",
    component: OpenOrder,
  },
  {
    path: "/inventory",
    name: "Inventory Page",
    component: InventoryPage,
  },
  {
    path: "/admin",
    name: "Admin Page",
    component: Admin,
  },
  {
    path: "/email",
    name: "Email Page",
    component: EmailPage,
  },
  // Customer Email and Dealer Email are one page, switched from the folder
  // sidebar (?side=customer|dealer). Accepts ?quoteId= or ?model= to open
  // straight onto one conversation.
  {
    path: "/customer-email",
    name: "Customer Email",
    component: CustomerEmailPage,
  },
  // Kept as a redirect so old links (and the nav-menu jump from Sales View
  // with ?model=) still land on the merged page with the dealer folder open.
  {
    path: "/dealer-email",
    name: "Dealer Email",
    component: DealerEmailPage,
  },
  {
    path: "/settings",
    name: "Settings",
    component: SettingsPage,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfilePage,
  },
  // Hidden debug page: backend application-log viewer. Intentionally absent
  // from the sidebar/navbar (Master.tsx) — reachable only by typing /logs in the
  // address bar. Still login-protected like every other admin route.
  {
    path: "/logs",
    name: "Application Logs",
    component: LogsPage,
  },
  { path: "*", name: "Not Found", component: NotFound },
];

export { AdminRoutes };
